module.exports = __webpack_public_path__ + "static/media/svg-6.72bf9ed2.svg";